type Props = {}

const SolidButton = (props: Props) => {
  return (
    <button>Solid Button</button>
  )
}

export default SolidButton
